import { useEffect,useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { useModalForms } from '../modalFormsContext'

import { MetasContext } from '../../goals/goalsContext'

import { Container } from './style'

export function ModalHeader() {
    const {idMeta,cancelEdit} = useContext(MetasContext);
    const { setChangeVisibleContent } = useModalForms()
    const openModalForms = useSelector(state => state.modalForms)
    const dispatch = useDispatch()

    useEffect(() => {
        if(openModalForms.isOpen === false){
            setTimeout(() => {
                setChangeVisibleContent(0)
            }, 300)
        }
    }, [openModalForms, setChangeVisibleContent])

    function handleCloseModal() {
        dispatch({ type: -1, title: openModalForms.title})
    }


    return(
        <Container>
            <h2>{openModalForms.title}</h2>
            <span 
                onClick={() => {idMeta.toString().length > 0 ? cancelEdit() : handleCloseModal()}}
            >
                &#10006;
            </span>
        </Container>
    )
}